<header id="page-topbar" >
    <div class="layout-width">
        <div class="navbar-header">
            <div class="d-flex">
                <!-- LOGO -->
                <div class="navbar-brand-box horizontal-logo">
                    <a routerLink="/" class="logo logo-dark">
                        <span class="logo-sm">
                            <img src="assets/images/login-logo.png" alt="" height="22">
                        </span>
                        <span class="logo-lg">
                            <img src="assets/images/logo.png" alt="" height="22">
                        </span>
                    </a>

                    <a routerLink="/" class="logo logo-light">
                        <span class="logo-sm">
                            <img src="assets/images/login-logo.png" alt="" height="22">
                        </span>
                        <span class="logo-lg">
                            <img src="assets/images/logo.png" alt="" height="22">
                        </span>
                    </a>
                </div>

                <button type="button" class="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger shadow-none" id="topnav-hamburger-icon" (click)="toggleMobileMenu($event)">
                    <span class="hamburger-icon">
                        <span></span>
                        <span></span>
                        <span></span>
                    </span>
                </button>

            </div>

            <div class="d-flex align-items-center">
                

                <div class="ms-1 header-item d-none d-sm-flex">
                    <button type="button" class="btn btn-icon btn-topbar btn-ghost-light rounded-circle user-name-text" data-toggle="fullscreen" (click)="fullscreen()">
                        <i class='ti ti-arrows-maximize fs-3xl'></i>
                    </button>
                </div>


                <div dropdown class="dropdown ms-sm-3 topbar-head-dropdown dropdown-hover-end header-item topbar-user">
                    <button dropdownToggle type="button" class="btn shadow-none btn-icon" id="page-header-user-dropdown">
                        <span class="d-flex align-items-center">
                            <img class="rounded-circle header-profile-user" src="assets/images/users/user-dummy-img.jpg" alt="Header Avatar">
                        </span>
                    </button>
                    <div *dropdownMenu class="dropdown-menu dropdown-menu-end">
                        <!-- item-->
                        <h6 class="dropdown-header">{{ this.userName }}</h6>
                        <a class="dropdown-item fs-sm" routerLink="/student/profile"><i class="bi bi-person-circle text-muted align-middle me-1"></i> <span class="align-middle"> Profile</span></a>
                        <a href="javascript:void(0);" class="dropdown-item fs-sm" (click)="logout()"><i class="bi bi-box-arrow-right text-muted align-middle me-1"></i> <span class="align-middle" data-key="t-logout"> Logout</span></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>
<div class="wrapper"></div>


